import { Component, OnInit, inject } from '@angular/core';
import { GoogleTagManagerService } from './services/utilities/google-tag-manager.service';
import { ToastrService } from 'ngx-toastr';
import { ThemeService } from './services/utilities/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    toastr = inject(ToastrService);
    private gtmService = inject(GoogleTagManagerService);
    private themeService = inject(ThemeService);


    ngOnInit(): void {
        this.themeService.initTheme();
        this.gtmService.addGtmToDom();
    }
}
